import { Languages } from "lucide-react";
import { LANGUAGES } from "../lib/languages";

/** Bascule ponctuelle de la langue de rédaction d'une génération IA (défaut = langue du patient). */
export const LangPicker = ({ value, onChange, patientLang, testId = "lang-picker", className = "" }) => (
  <label className={`inline-flex items-center gap-1 text-xs text-muted-foreground ${className}`} title="Langue de rédaction (défaut : langue du patient)">
    <Languages className="w-3.5 h-3.5" />
    <select value={value || ""} onChange={(e) => onChange(e.target.value)} className="h-8 rounded-md border border-border bg-background px-1.5 text-xs" data-testid={testId}>
      <option value="">{patientLang ? `Langue du patient (${patientLang.toUpperCase()})` : "Langue du patient"}</option>
      {LANGUAGES.map((l) => <option key={l.id} value={l.id}>{l.label}</option>)}
    </select>
  </label>
);
